import { Component, OnInit, Input } from '@angular/core';
import { ComboChartConfig } from '../../../../../shared/google-chart/Models/ComboChartConfig';

@Component({
	selector: 'app-site-truck-ebus-report',
	templateUrl: './site-truck-ebus-report.component.html',
	styleUrls: ['./site-truck-ebus-report.component.css']
})
export class SiteTruckEbusReportComponent implements OnInit {
	@Input() data: any;
	@Input() siteId: number = 0;
	@Input() customerId: number = 0;
	// @Input() siteBattviewsData: any = {};
	@Input() siteTags: any = {};
	// @Input() siteBattviewsTags: any = {};
	@Input() customerName: string = '';
	@Input() siteName: string = '';

	config: ComboChartConfig;
	tableColumns: any[] = [
		{title: "Truck ID", property: "truck_id"},
		{title: "Max EBUs", property: "max_ebu"},
		{title: "Avg EBUs", property: "avg_ebu"},
	];
	title: string = 'Site EBUs';
	elementId: string = 'site_truck_ebus';
	widgetClass: string = 'auto-height-widget';
	siteWidgetOptions: any = {
		hasOperation: true,
		hasDate: true,
		hideYesterdayDate: true,
		isReport: true,
		updateChartMaxValue: true,
		updateChartSeries: true,
		hasSiteEbuCheckBox: true,
		isTrucks: true,
	};

	constructor() { }

	ngOnInit() {
		let series: any = {};
		let vAxis: any = {
			title: 'EBU Value',
			titleTextStyle: {color: 'black', fontSize: 18},
			maxValue: 100,
			minValue: 0,
			gridlines: {count: 10}
		};
		this.config = new ComboChartConfig(vAxis, series, {height: '60%'});
		this.config.updateColumns = (data, options) => {
			let columnsArray = [
				{title: "Truck ID", property: "truck_id"},
			];
			if(options.max_ebu) {
				columnsArray.push({title: "Max EBUs", property: "max_ebu"});
			}
			if(options.avg_ebu) {
				columnsArray.push({title: "Avg EBUs", property: "avg_ebu"});
			}
			return columnsArray;
		};
	}
}